import request from '../utils/request';

export const addImage = async (image: string) => {
  return await request.rpc('image/add', {
    base64: image,
  });
};

export const getImage = async (id: string) => {
  return await request.rpc('image/get', {
    id: id,
  });
};

export const uploadImage = async (image: string) => {
  return await request.rpc('image/upload_image', {
    url: image,
  });
};
